import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayToPills'
})
export class ArrayToPillsPipe implements PipeTransform {

  transform(value: string[], ...args: unknown[]): unknown {
    return value?.map(val => {
      return {value: val, selected: true}
    });
  }

}
